import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../shared/AppSettings';
import { tBedModel } from '../models/tBedModel';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';



@Injectable({
    providedIn: 'root'
})

export class tBedService {

    constructor(private http: HttpClient) { }

    baseurl: string = AppSettings.BaseURI;

    readonly pathName = '/Bed';

    getAllData() {
        return this.http.get<tBedModel[]>(this.baseurl + this.pathName).pipe(shareReplay(1));
    }

    getAllBedDataByShop(shopID: number) {
        return this.http.get<tBedModel[]>(this.baseurl + this.pathName+ '/getAllDataByShop/'+shopID);
    }

    

    getAllDataByShopID(shopID: string, date: string, clthConsultNumber: string) {
        return this.http.get<tBedModel[]>(this.baseurl + this.pathName + '/ByShopID/' + shopID + '/' + date + '/' + clthConsultNumber);
    }

    getDataById(id: string) {
        return this.http.get<tBedModel>(this.baseurl + this.pathName + '/' + id);
    }

    addData(data: tBedModel) {
        return this.http.post(this.baseurl + this.pathName, data).pipe(shareReplay(1));
    }

    deleteData(data: tBedModel) {
        return this.http.delete(this.baseurl + this.pathName + '/' + data.bedID);
    }

    updateData(data: tBedModel) {
        //   data.lastModifyLoginName = "2";
        return this.http.put(this.baseurl + this.pathName + '/' + data.shopID, data);
    }
}